import { render, staticRenderFns } from "./DialogContent.vue?vue&type=template&id=2bd0ca7e&"
import script from "./DialogContent.vue?vue&type=script&lang=js&"
export * from "./DialogContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports